<script setup lang="ts">
import type { Extensions, JSONContent } from "@tiptap/core";
import { Document } from "@tiptap/extension-document";
import { Heading } from "@tiptap/extension-heading";
import { Text } from "@tiptap/extension-text";
import { Twemoji } from "~/tiptap/twemoji";
import { Placeholder } from "@tiptap/extension-placeholder";
import { History } from "@tiptap/extension-history";
import { Dropcursor } from "@tiptap/extension-dropcursor";
import { Gapcursor } from "@tiptap/extension-gapcursor";
import { Typography } from "@tiptap/extension-typography";
import { HocuspocusProvider } from "@hocuspocus/provider";

const { t } = useI18n()

const props = defineProps<{
  provider: HocuspocusProvider | null
  field?: string
  content: JSONContent | null
  editable?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:content', value: JSONContent | null): void
}>()

const extensions = computed(() => [
  // nodes
  Document.configure({
    content: 'heading'
  }),
  Heading.configure({
    levels: [1]
  }),
  Text,
  Twemoji,
  // utils
  props.provider ? null : History,
  Placeholder.configure({
    showOnlyCurrent: false,
    placeholder: t('jc.component.newsEditorBody.placeholder'),
  }),
  Dropcursor,
  Gapcursor,
  Typography,
].filter(e => e !== null) as Extensions)
</script>

<template>
  <CollaborationEditor
    :provider="props.provider"
    :field="props.field"
    :content="props.content"
    @update:content="val => emit('update:content', val)"
    :extensions="extensions"
    :editable="props.editable"
  />
</template>
